// extracted by mini-css-extract-plugin
export default {"root":"amount-toggle_root__pYKt6","plus":"amount-toggle_plus__grT4A","minus":"amount-toggle_minus__N4Ptt","amount":"amount-toggle_amount__qkFho"};